import { MapSchema, Schema, type } from "@colyseus/schema"
import { CardWithPlayerClass } from "./сard"

export type CardsRange = 0 | 1 | 2 | 3 | 4 | 5

export class CardsOnTableClass extends Schema {
  @type({ map: CardWithPlayerClass })
  defendingCards = new MapSchema<CardWithPlayerClass>()

  @type({ map: CardWithPlayerClass })
  attackingCards = new MapSchema<CardWithPlayerClass>()

  constructor() {
    super()

    this.defendingCards = new MapSchema<CardWithPlayerClass>()
    this.attackingCards = new MapSchema<CardWithPlayerClass>()
  }

  pushToAttackingCards(card: CardWithPlayerClass): string {
    const nextKey = this.attackingCards.size.toString()

    this.attackingCards.set(nextKey, card)

    return nextKey
  }
}

export type CardsOnTable = InstanceType<typeof CardsOnTableClass>
